import { Fragment, useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Button, Form, Stack } from "react-bootstrap";
import useAxios from "axios-hooks";
import BrandContext from "./BrandContext";
import { LinkContainer } from "react-router-bootstrap";

export default function Pitch(props) {
    const theme = useContext(BrandContext);
    const params = useParams();
    const nav = useNavigate();
    const [pitch, setPitch] = useState('')


    const [{ data: currentPR, loading: loadingPR, error: prError }, refetchPR] = useAxios({
        method: 'get',
        url: '/pr/get',
        params: {
            id: params.prId
        },
    });
    useEffect(() => {
        // Content wasn't completed, go back to content
        if (currentPR && !currentPR?.prTitle) {
            nav('../content');
            return;
        }
        const status = currentPR?.status;
        switch (status) {
            case 'paid':
                nav('../checkout');
                return;
            case 'submitted':
                nav('../submitted');
                return;
            default:
                break;
        }
    }, [currentPR]);

    const [
        { loading: working },
        executePut
    ] = useAxios(
        {
            url: '/pr/pitch',
            method: 'POST'
        },
        { manual: true }
    )

    function updatePitch() {
        executePut({
            data: {
                id: params.prId,
                pitch
            }
        })
            .then((r) => {
                nav('../promote')
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {

            })
    }

    return (
        <Fragment>
            <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <Row>
                    <Col sm={{ span: true, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                        <p style={{ fontSize: "14px" }}><span className="sr-light">Create</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="fw-bold">Promote</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="sr-light">Submit</span></p>
                        <p className="fw-bold" style={{ fontSize: "24px", lineHeight: "26px" }}>Do you have a message for our editors?</p>
                        <p>Or a pitch? Let our editors know what makes your press release newsworthy and valuable to our audience. Optional.</p>
                    </Col>
                    <Col sm={{ span: 'auto', order: 'last' }} xs={{ span: 12, order: 'first' }} style={{ padding: "15px", display: "grid", alignContent: "start", justifyContent: "start" }}>
                        <Image style={{ height: "50px" }} fluid src={theme?.marketing?.logo}></Image>
                    </Col>
                </Row>
                {currentPR &&
                    <Fragment>
                        <Row>
                            <Col md="12">
                                <Form.Control autoFocus tabIndex={1} as="textarea" rows={4} style={{ resize: "none" }}
                                    onChange={(e) => { setPitch(e.target.value) }} required minLength={1} maxLength={500}
                                    defaultValue={currentPR?.pitch || ''} />
                            </Col>
                        </Row>
                        <Stack direction="horizontal" gap={3} style={{ marginTop: "24px" }}>
                            <Button onClick={() => updatePitch()} disabled={working} size="lg" variant="swiftrev">Next</Button>
                            <LinkContainer to="../content">
                                <Button size="lg" variant="none">Back</Button>
                            </LinkContainer>
                        </Stack>
                    </Fragment>
                }
            </Container>
        </Fragment>
    );
}